














































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import GoBack from '@/components/GoBack.vue'
import Icon from '@/components/Icon.vue'
import DropdownNav from '@/components/DropdownNav.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { mapGetters } from 'vuex'
import { User } from '@/classes/User'
import Api from '@/api'
import { EResidentStatus, EUserPermissions, IResident, IResidentFiltersDTO } from '@zunta/configurations'
import PortalInvitationPopup from '@/views/app/management/components/PortalInvitationPopup.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ResidentTabs from '@/views/app/management/residents/resident-page/components/ResidentTabs.vue'
import Confirm from '@/components/Confirm.vue'
import Switcher from '@/components/Switcher.vue'
import ResidentAgingWidget from '@/views/app/management/residents/resident-page/widgets/ResidentAgingWidget.vue'
import ResidentStatementWidget from '@/views/app/management/residents/resident-page/widgets/ResidentStatementWidget.vue'
import ResidentAutoPaymentWidget
  from '@/views/app/management/residents/resident-page/widgets/ResidentAutoPaymentWidget.vue'
import ResidentLastPaymentWidget
  from '@/views/app/management/residents/resident-page/widgets/ResidentLastPaymentWidget.vue'
import ResidentHistoryWidget from '@/views/app/management/residents/resident-page/widgets/ResidentHistoryWidget.vue'
import ResidentContactsWidget from '@/views/app/management/residents/resident-page/widgets/ResidentContactsWidget.vue'
import { VPopover } from 'v-tooltip'
import Card from '@/components/Card.vue'
import TabsV3 from '@/components/layout/TabsV3.vue'

enum residentNavigationModes {
  NEXT = 'NEXT',
  PREV = 'PREV',
}

@Component({
  components: {
    TabsV3,
    Card,
    ResidentContactsWidget,
    ResidentHistoryWidget,
    ResidentLastPaymentWidget,
    ResidentAutoPaymentWidget,
    ResidentStatementWidget,
    ResidentAgingWidget,
    Switcher,
    Confirm,
    ResidentTabs,
    LoaderWrapper,
    PortalInvitationPopup,
    DropdownNav,
    Icon,
    GoBack,
    VPopover
  },
  computed: {
    ...mapGetters({
      residentsList: 'resident/getResidents',
      filters: 'resident/getFilters'
    })
  }
})
export default class Resident extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  residentNavigationModes: any = residentNavigationModes
  EUserPermissions: any = EUserPermissions
  EResidentStatus: any = EResidentStatus
  user: User = Api.getUser() as User

  residentsList!: IResident[]
  filters!: IResidentFiltersDTO

  invitationPopupOpened: boolean = false
  isLoading: boolean = false
  showExcludeFromCollectionConfirm: boolean = false
  showExcludeFromStatementsConfirm: boolean = false
  isSidebarOpened: boolean = false

  get tabs () {
    const tabs: any = [
      {
        label: 'Dashboard',
        icon: 'dashboard',
        to: { name: 'management-resident' }
      },
      {
        label: 'Aging',
        icon: 'chart',
        to: { name: 'management-resident-aging' }
      }
    ]
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_MAILINGS)) {
      tabs.push({
        label: 'Statement',
        icon: 'task',
        to: { name: 'management-resident-statement' }
      })
    }

    if (this.user.hasPermissionFor(EUserPermissions.VIEW_AUTOPAY)) {
      tabs.push({
        label: 'Auto Payments',
        icon: 'money',
        to: { name: 'management-resident-auto-payments' }
      })
    }

    if (this.user.hasPermissionFor(EUserPermissions.VIEW_PAYMENTS)) {
      tabs.push({
        label: 'Payments',
        icon: 'clock',
        to: { name: 'management-resident-payments-history' }
      })
    }

    tabs.push(
      {
        label: 'Comments',
        icon: 'comment',
        to: { name: 'management-resident-history' }
      },
      {
        label: 'Contacts',
        icon: 'users',
        to: { name: 'management-resident-contacts' }
      },
      {
        label: 'Payment Methods',
        icon: 'credit-card',
        to: { name: 'management-resident-payment-methods' }
      }
    )

    return tabs
  }

  get residentId () {
    return this.$route.params.id
  }

  get isMirror () {
    return this.$route.params.isMirror
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get residentPaymentOptions () {
    const options = [
      {
        value: 'payment-one-time',
        key: 'payment-one-time',
        content: 'One time'
      }
    ]
    if (this.user.hasPermissionFor(EUserPermissions.CREATE_AUTOPAY)) {
      options.push({
        value: 'payment-autopay',
        key: 'payment-autopay',
        content: 'Autopay'
      })
    }
    return options
  }

  mounted () {
    this.fetchData()
    this.$watch('residentId', () => this.fetchData())
    this.watchWW()
    window.addEventListener('resize', this.watchWW)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.watchWW)
  }

  watchWW () {
    // @ts-ignore
    this.toggleSidebar(window.innerWidth > 1920)
  }

  async fetchData (residentId?: number) {
    try {
      this.isLoading = true
      if (!this.residentsList.length) {
        await this.residentModuleInstance.getResidentsFilteredList(this.filters)
      }
      await this.residentModuleInstance.fetchResidentById(residentId || this.residentId)
    } finally {
      this.isLoading = false
    }
  }

  async changeResidentSetting (settingName: string, value: boolean) {
    const actionAllowed =
      this.user.hasPermissionFor(EUserPermissions.EDIT_RESIDENT_SETTINGS) ||
      (this.user.isResident() && settingName === 'paperlessStatement')

    if (actionAllowed) {
      await this.residentModuleInstance.updateResidentSettings({
        residentId: parseInt(this.residentId, 10),
        settings: { [settingName]: value }
      })
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Permission Denied',
      header: `Modify Resident Settings`,
      icon: 'warning'
    })
  }

  changeExcludeFromCollection () {
    this.changeResidentSetting('excludeFromCollections', !this.resident.excludeFromCollections)
    this.toggleExcludeFromCollectionsConfirm(false)
  }

  changeExcludeFromStatements () {
    this.changeResidentSetting('stopSendingStatements', !this.resident.stopSendingStatements)
    this.toggleExcludeFromStatementsConfirm(false)
  }

  toggleExcludeFromCollectionsConfirm (value: boolean) {
    this.showExcludeFromCollectionConfirm = value
  }

  toggleExcludeFromStatementsConfirm (value: boolean) {
    this.showExcludeFromStatementsConfirm = value
  }

  getResidentStatusLabel (status: EResidentStatus) {
    const STATUSES_MAP: any = {
      [EResidentStatus.ACTIVE]: 'Current',
      [EResidentStatus.INACTIVE]: 'Discharged'
    }
    return STATUSES_MAP[status]
  }

  canNavigateToResident (resident: IResident, mode: residentNavigationModes): boolean {
    switch (mode) {
      default:
      case residentNavigationModes.NEXT:
        return typeof resident.nextResident === 'object'
      case residentNavigationModes.PREV:
        return typeof resident.prevResident === 'object'
    }
  }

  navigateToResident (resident: IResident, mode: residentNavigationModes): void {
    if (this.canNavigateToResident(resident, mode)) {
      const residentId = mode === residentNavigationModes.NEXT
        ? (resident.nextResident as IResident).id
        : (resident.prevResident as IResident).id
      this.$router.push({
        name: this.$route.name ? this.$route.name : 'management-resident',
        params: {
          id: residentId.toString()
        }
      })
    }
  }

  goTo (options: any): void {
    this.$locationManager.rememberAndGoTo(options).catch((e: any) => e)
  }

  toggleInvitationPopup (value: boolean): void {
    this.invitationPopupOpened = value
  }

  toggleSidebar (value: boolean | null = null) {
    this.isSidebarOpened = value !== this.isSidebarOpened && value === null
      ? !this.isSidebarOpened
      : value
    setTimeout(() => this.$eventBus.$emit('resize'), 200)
  }
}
